import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import ServiceImg1 from '../../assets/images/services/3.png';
import ServiceImg2 from '../../assets/images/services/1.png';
import ServiceImg3 from '../../assets/images/services/2.png';
import ServiceImg4 from '../../assets/images/services/4.png';
import ServiceImg5 from '../../assets/images/services/5.png';

// Swiper options
const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 2,
  spaceBetween: 30,
  speed: 2000,
  autoplay: {
    delay: 9000,
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next1',
    prevEl: '.swiper-button-prev1',
  },
  pagination: {
    el: '.swiper-dot-style1',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    0: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
    375: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    575: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    768: {
      spaceBetween: 30,
      slidesPerView: 1,
    },
    992: {
      spaceBetween: 30,
      slidesPerView: 2,
    },
    1200: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
    1320: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
  },
};

// Sample service data
const services = [
  {
    imgName: ServiceImg1,
    title: 'Managed IT Services',
    link: '/managed-it-services',
    description: 'Managed IT solutions are designed to be there around the clock to ensure companies market.',
  },
  {
    imgName: ServiceImg2,
    title: 'Security Consulting',
    link: '/security-consulting',
    description: 'Security Consulting to address IT Security requirements across Network consulting services',
  },
  {
    imgName: ServiceImg3,
    title: 'Audit & Compliance',
    link: '/audit-&-compliance',
    description: ' VAPT Services, Security audit and guidance in implementing regulatory compilance solutions',
  },
  {
    imgName: ServiceImg4,
    title: 'Cloud Security',
    link: '/cloud-security',
    description: ' Manage, optimize and enhance cloud efficiency, storage & databases access to software',
  },
  {
    imgName: ServiceImg5,
    title: 'Design & implementation',
    link: '/design-&-implementation',
    description: 'Solution Design and Implementation Services, Testing and Commissions automated work ',
  },
];

export default function ServicesOne() {
  return (
    <section className="services-one">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">WHAT WE DO</span>
          </div>
          <h2 className="section-title__title">
          Services <span>We Offer</span>
          </h2>
        </div>
        <div className="services-one__carousel">
          <Swiper {...swiperOptions}>
            {services.map((service, index) => (
              <SwiperSlide key={index}>
                <div className="services-one__single">
                  <div className="services-one__img-box">
                    <div className="services-one__img">
                      <img
                        src={`${service.imgName}`}
                        alt={service.title}
                      />
                    </div>
                    {/* <div className="services-one__icon">
                      <span className="icon-paint"></span>
                    </div> */}
                  </div>
                  <div className="services-one__content">
                    <h3 className="services-one__title">
                      <Link to={service.link}>{service.title}</Link>
                    </h3>
                    <p className="services-one__text">{service.description}</p>
                    <div className="services-one__btn-box">
                      <Link to={service.link} className="services-one__btn thm-btn">
                        Read more
                        <span className="icon-dubble-arrow-right"></span>
                      </Link>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/* Navigation Buttons */}
        {/* Pagination */}
      </div>
    </section>
  );
}
